module.exports = __webpack_public_path__ + "img/jawg-sunny.eb2c0d72.jpg";